import React, { Component } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import ProgressBar from "./ProgressBar";
import SecretKeyForm from "./SecretKeyForm";
import KeyholdersCard from "../RegistrationStep/KeyholdersCard";
import FinalStep from "./FinalStep";
import LoadingOverlay from "../../Components/LoadingOverlay";
import { APP_CONST, getStoredItem } from "../../../store/dataStore";
import keyholderApi from "../../../api/keyholder";
import { handleError as originalHandleError } from "@/util/errorHandler";

const handleError = error =>
  originalHandleError(error, { title: error.detail });

class Reinstallation extends Component {
  state = {
    isLoading: true,
    step: 0,
    secretKey: null,
    aeskey: null,
    keyholdersList: [],
  };

  componentDidMount() {
    this.fetchKeyholdersList()
      .then(() => {
        this.checkCurrentKeyholderStatus();
      })
      .catch(handleError);
  }

  /*
   * checks current keyholder status from keyholderList
   * and shows final step if keyholder has sended his secretKey
   */
  checkCurrentKeyholderStatus = () => {
    let {
      userAccountDTO: { login },
    } = JSON.parse(getStoredItem(APP_CONST.USER_INFO));

    const statusOfCurrentKeyholder = this.state.keyholdersList.find(
      k => k.username === login,
    );

    if (!statusOfCurrentKeyholder) {
      throw new Error("Current keyholder not found in keyholder list");
    }

    if (statusOfCurrentKeyholder.status) {
      this.onGoToFinalStep();
    }
  };

  fetchKeyholdersList = async () => {
    try {
      return await keyholderApi.getKeyholdersList().then(keyholdersList => {
        this.setState({ keyholdersList });
      });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  onSubmit = async hash => {
    try {
      const keyholdersList = await keyholderApi.submitSecretKeyHash(hash);
      this.setState({ keyholdersList }, () => {
        this.updateStatus();
      });
    } catch (err) {
      handleError(err);
    }
  };

  updateStatus = async () => {
    try {
      this.checkCurrentKeyholderStatus();
      if (this.state.keyholdersList.every(k => k.status)) {
        await keyholderApi.createBankAccountRequest();
      }
    } catch (err) {
      handleError(err);
    }
  };

  onGoToFinalStep = () => this.setState({ step: 1 });

  render() {
    const { isLoading, step, keyholdersList } = this.state;

    return (
      <Card>
        <CardBody>
          <LoadingOverlay loading={isLoading} />
          <Card>
            <CardBody>
              <ProgressBar step={step} />
            </CardBody>
          </Card>

          <Row>
            <Col lg="8" sm="7">
              {step === 0 && <SecretKeyForm onSubmit={this.onSubmit} />}
              {step === 1 && (
                <FinalStep
                  isEachSecretKeySubmitted={keyholdersList.every(k => k.status)}
                />
              )}
            </Col>
            <Col lg="4" sm="5">
              <KeyholdersCard keyholdersList={keyholdersList} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
}

export default Reinstallation;
